import { useTranslation } from 'react-i18next';
import { TaxReturnSummaryFormSideOverPageProps } from './types';
import { StandardTaxReturnSummaryForm } from '../../../TaxReturnSummary';
import { ElementsButton, SideOverFooter, SideOverHeaderNew, SideOverHeading } from '../../components';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SMTailwindMinPixelBreakpointWidth } from '../../../util/theme.util';

export function TaxReturnSummaryFormSideOverPage({
  exit,
  isLoading,
  allowDocuments,
  sideOverHeaderChildren,
  useTaxReturnSummaryFormReturn,
  isEdit = false,
  showNotes = false,
}: TaxReturnSummaryFormSideOverPageProps) {
  const { t: tTaxes } = useTranslation('taxes');
  const { t: tCommon } = useTranslation('common');
  const isMobile = useMediaQuery(`(max-width: ${SMTailwindMinPixelBreakpointWidth}px)`);

  return (
    <>
      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')}>
        {sideOverHeaderChildren}
      </SideOverHeaderNew>

      <div className="md:px-10 px-6">
        <SideOverHeading
          heading={isEdit ? tTaxes('edit-taxes') : tTaxes('add-taxes')}
          className="md:!mt-[25px] mb-14"
        />

        {useTaxReturnSummaryFormReturn.formReady && (
          <StandardTaxReturnSummaryForm
            className="mb-28 md:mb-36"
            useTaxReturnSummaryFormReturn={useTaxReturnSummaryFormReturn}
            visibilityOptions={{
              hideFileList: !allowDocuments,
              hideCreateFileInput: !allowDocuments,
              hideNotes: !showNotes,
            }}
          >
            <SideOverFooter>
              <ElementsButton
                icon="check"
                iconPosition="left"
                isLoading={isLoading}
                label={tCommon('save')}
                size={isMobile ? 'small' : 'large'}
              />
            </SideOverFooter>
          </StandardTaxReturnSummaryForm>
        )}
      </div>
    </>
  );
}
